import { supabase } from "../supabaseClient";

async function getAllTransactions(from, to, searchValue, sortBy, selectedDate, leadId) {
	// const limit = 10;
	// const fromCount = nextRange?.from;
	// const toCount = nextRange?.to;
	let query = supabase
		.rpc("get_transaction_data", { search_text: searchValue, leadid: leadId }, { count: "exact" })
		.order("paymentdate", {
			ascending: sortBy.includes("Oldest") ? true : false,
		})
		.range(from, to);

	if (selectedDate?.[0]?.value !== "" && selectedDate?.[1]?.value !== "" && selectedDate !== undefined) {
		query = query
			.lte("paymentdate", Date.parse(new Date(selectedDate?.[1]?.value)))
			.gte("paymentdate", Date.parse(new Date(selectedDate?.[0]?.value)));
	}
	const { data, count, error } = await query;
	if (data) return { data, count };
	else throw error;
}

export { getAllTransactions };
